import clsx from 'clsx';
import { BoxVariant } from './types';

export const getBackgroundForVariant = (variant: BoxVariant): string => {
  switch (variant) {
    case 'filled':
      return clsx('bg-componentBackground');
    case 'background':
      return clsx('bg-background');
    default:
      return clsx('bg-white');
  }
};
